import Image from './TribeClaimsList';

export default Image;
